/* loaded by smart-asset */
export default require("./times-circle-solid~bcWEkhuj.svg")